import { SEO } from '~modules'
import { JsonLD } from '~elements'
import { Page as DefaultPage } from '~modules'
import { BASE_URLS, SLUG_HOMEPAGE } from '~constants'
import { PageData } from '~types'
import { getStaticPropsForPage } from '../lib/hygraph/getStaticPropsForPage'

export default function Home({ story, preview }: PageData) {
  const { content } = story
  const { body } = content
  const { seo, title } = body

  const structuredData = {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    image: '',
    url: BASE_URLS.prod,
    name: 'Sphere',
    description:
      'Sphere is a music and entertainment arena in Paradise, Nevada, United States, east of the Las Vegas Strip.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '255 Sands Ave. Las Vegas',
      addressRegion: 'NV',
      postalCode: '89169'
    }
  }

  return (
    <>
      <JsonLD data={structuredData} />
      <SEO {...seo} defaultTitle={title} />
      <DefaultPage content={content} preview={preview} />
    </>
  )
}

export async function getStaticProps({ preview = false }) {
  return await getStaticPropsForPage({ slug: SLUG_HOMEPAGE, preview })
}
